module.exports = __webpack_public_path__ + "img/bemz.ff44edba.png";